import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { gsap } from "gsap";
import $ from "jquery";
import CSSRulePlugin from "gsap/CSSRulePlugin";

import RoleOptions from "../../components/RoleOptions/RoleOptions";
import Nav1 from "../../components/Navigation/Nav1/Nav1";
import Results from "../../components/Results/Results";

import { useSkip } from "../../customHooks/customHooks";

import LandingSet from "../../libs/LandingSet";

import Panel from "./Panel/Panel";

import * as actionCreators from "../../store/actions/index";



import "./Panels.scss";
let ariaAnnouncement='';
let labArray=['landing page'];
const Panels = (props) => {
  const [panlPosition, setPanlPosition] = useState(0);

  const changeRoleHandlr = (role, lang) => {
    //ACC

    props.onChangeRole(role, lang);
    props.onChooseQuestions(role, lang);
  };


  let isActive=("false");
  useEffect(() => {
    localStorage.setItem("currLang", "English");
    const search = window.location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    const role = String(params.get("role")).replace(/@/g, "&"); // bar
    const score = params.get("score"); // bar
    const lang = params.get("lang");

    //ACC
    document.getElementById('Next_undefined').disabled=true;

    if (lang !== null) {
      props.onChangeLang(lang);
      $(`.${lang}`).prop("selected", "selected");
      $(".ochat_slideout").addClass(props.currentLang);
      $(".ochat_modal").addClass(props.currentLang);
    }
    if (role !== null && score !== null) {
      gsap.to("html", { opacity: 1, delay: 1 });
      gsap.to(".Panels", {
        y: "-700vh",
      });
      gsap.to(".Spider__Container", {
        y: 0,
      });

      if (Number($("body").width()) < 1025) {
        const rule = CSSRulePlugin.getRule(".Header:after");
        gsap.to(rule, {
          backgroundColor: "#233b3f",
        });
      }
      gsap.to(".Background__wrapper--1", {
        y: "-100%",
      });
      gsap.to(".Background__wrapper--2", {
        y: "-100%",
      });
      const initScore = score.split("_");
      props.onChangeRole(role, lang);
      props.onChangeLang(lang);
      props.onChooseQuestions(role, lang);
      props.onUpdatePeerScores(role);
      props.onInitQuestions(initScore);
      const perfSet = [];
      initScore.forEach((score, i) => {
        if (score === "100") {
          perfSet.push(i);
        }
      });
      const bulletNodes = $(".Bullet");
      const spiderNodes1 = $(".Spider__node--1");
      const spiderNodes2 = $(".Spider__node--2");
      $(".Header").addClass("Header--1");
      if (perfSet.length > 0) {
        perfSet.forEach((perfScoreIdx) => {
          $(bulletNodes[perfScoreIdx]).removeClass("Bullet--2");
          $(bulletNodes[perfScoreIdx]).addClass("Bullet--1");
          $(spiderNodes1[perfScoreIdx]).hide();
          $(spiderNodes2[perfScoreIdx]).hide();
        });
      }
    } else {
      $("html").addClass("show");
    }
  }, []);

  const answerChangeHandlr = () => {
    $('.Nav1--3').disabled=('false')
    
  };


  const panelMovementHandlr = (direction) => {
    for(let i=0; i< panels.length;i++){
      document.getElementById(`Next_${(i)}`).disabled=true;
    }

    let num = direction ? panlPosition - 100 : panlPosition + 100;
    const panlNum = direction ? 1 : -1;
    setPanlPosition(num);
    props.onNavQuestion(panlNum);


    //this is a bunch of nonsense to keep the results panel from scrolling too far
    let offset =
      -(
        ($(".Panel__results .Panel__wrapper--2").height() -
          $(window).height()) /
        2
      ) + 50;

 
 // ACC
 let qnum= (Math.abs(num)/100)-1
  $(`.Panel--${(qnum)}`).show();
  $('.Panel').removeClass('active');
  $(`.Panel--${(qnum)}  .Nav1--3`).disabled=false;
  $(`.Panel--${(qnum)}`).addClass('active');
 


  ariaAnnouncement=`Question ${props.currentQuestion+1} of 7`;
  if(direction===false){
    if(props.currentQuestion>1){
      document.getElementById('Next_'+qnum).disabled=false;
      document.getElementById('Next_'+qnum).disabled=false;

    }
    else{
      document.getElementById('Next_undefined').disabled=false;
      document.getElementById('role').disabled=false;
    }
  }
  if(props.currentQuestion+1===1){
    document.getElementById('Next_undefined').disabled=true;
    document.getElementById('role').disabled=true;
  }
  if(qnum ==panels.length){
    $(`.Panel__results`).addClass('active');
  }
    setTimeout(function () {
      $(`#Prev_${(qnum)}`).trigger("focus");
    }, 1000);

    gsap.to(".Panel", {
      y: `${num}vh`,
      duration: 1,
    });
  };


  useSkip(() => {
    animateIfSkip();
    props.onNavQuestion(1);
    setPanlPosition(-100);
  }, [Nav1]);

  const panels = props.currentQuestions.map((question) => {
    question.currQ = question.questionSet[props.currentLang];
    question.currA = question.answerSet[props.currentLang];
    question.currH = question.headerSet[props.currentLang];
    question.currCV = question.custVals;
    labArray.push( question.currH)
    return question;
  });

  return (
    <div className="Panels">
      <div id="sr-only" className="sr-only" aria-live="polite"> {ariaAnnouncement}
      </div>
      <Panel classAdd="__landing" >
        <h1 className={`Landing__title ${props.currentLang}`}>
          <span>{LandingSet.title1[props.currentLang]}</span>
          {/* <span>{LandingSet.title2[props.currentLang]}</span> */}
        </h1>
        <hr className="Landing__hr" />
        <div className="Landing__text">
          <p>{LandingSet.landingCopy[props.currentLang]}</p>
           <p>{LandingSet.landingCopy2[props.currentLang]}</p> 
        </div>
        <div className="Nav-Role__container">
          <RoleOptions
            changed={changeRoleHandlr}
            roles={props.EXISTING_ROLES}
          />
          <Nav1
            text={LandingSet.getStarted[props.currentLang]}
            type={0}
            clicked={panelMovementHandlr}
          />
        </div>
      </Panel>
      {

      panels.map((panel, i) => (
        <Panel
          classAdd="__question"
          pnlMvmtHnldr={panelMovementHandlr}
          pnl={panel}
          pnlsLen={panels.length}
          key={`panel-${i}`}
          pnlIdx={i}
          isActiv={isActive}
          prevLabel={labArray[i]}
          changeHandlr={answerChangeHandlr}
        />
      ))}
      <Panel classAdd="__results" isActive={props.isActive}>
        {/* <div className="">IN PROGRESS****</div> */}
        <Results />
        {/* <Footer/> */}
      </Panel>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentRole: state.roleReducer.currentRole,
    EXISTING_ROLES: state.roleReducer.EXISTING_ROLES,
    currentLang: state.langReducer.currentLang,
    EXISTING_LANGS: state.langReducer.EXISTING_LANGS,
    currentQuestions: state.questionsReducer.currentQuestions,
    currentQuestion: state.questionsReducer.currentQuestion,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeRole: (role, lang) =>
      dispatch(actionCreators.choose_role(role, lang)),
    onChangeLang: (lang) => dispatch(actionCreators.choose_lang(lang)),
    onChooseQuestions: (role, lang) =>
      dispatch(actionCreators.choose_questions(role, lang)),
    onNavQuestion: (dir) => dispatch(actionCreators.nav_question(dir)),
    onInitQuestions: (arr) => dispatch(actionCreators.init_scores(arr)),
    onUpdatePeerScores: (r) => dispatch(actionCreators.update_peerscore(r)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Panels);

function animateIfSkip() {
  const num = -100;
  // setBgPosition(num);

  const anim = gsap.timeline();

  anim.to(".Background__wrapper", {
    y: `${num}%`,
    duration: 0,
  });

  gsap.to(".Nav2__wrapper", {
    y: `0`,
    duration: 0,
  });
  gsap.to(".Spider__Container", {
    y: "0",
    duration: 0,
  });

  gsap.to(".Panel", {
    y: `-100vh`,
    duration: 0,
  });

  gsap.to(".Header__restart", {
    opacity: 1,
    duration: 0,
    pointerEvents: "auto",
  });
}
